import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/dayjs';
import './index.css';
import './styles/app.scss';

import { Main } from './pages/Main/Main';
import { ThemeProvider } from './contexts/ThemeContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider>
    <Main />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
